import React, { useState, useRef, useEffect, useCallback } from 'react';
import useOutsideClick from '../../hooks/useOutsideClick';

const ZoobbeSelect = ({
    options,
    defaultSelectedOption,
    onSelect,
    className = '',
    isDisabled = false,
    disabled = false,
    showDescription = false,
    value
}) => {
    const isValidDefaultIndex =
        typeof defaultSelectedOption === 'number' &&
        defaultSelectedOption >= 0 &&
        defaultSelectedOption < options.length;

    // Ensure the default selection is valid; otherwise, fall back to the first option or undefined
    const [selectedOption, setSelectedOption] = useState(
        isValidDefaultIndex ? options[defaultSelectedOption] : options[0] || undefined
    );

    const [isOpen, setIsOpen] = useState(false);
    const [openUp, setOpenUp] = useState(false);
    const selectRef = useRef();
    const triggerRef = useRef();

    // Update selected option when value prop changes
    useEffect(() => {
        if (value !== undefined) {
            const option = options.find(opt => opt.value === value);
            if (option) {
                setSelectedOption(option);
            }
        }
    }, [value, options]);

    // Check if dropdown should flip upward when there's not enough space below
    const checkFlip = useCallback(() => {
        if (!triggerRef.current) return;
        const rect = triggerRef.current.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.bottom;
        setOpenUp(spaceBelow < 220);
    }, []);

    useEffect(() => {
        if (isOpen) {
            checkFlip();
        }
    }, [isOpen, checkFlip]);

    useOutsideClick(selectRef, () => {
        setIsOpen(false);
    });


    const handleOptionClick = (option) => {
        setSelectedOption(option);
        setIsOpen(false);
        onSelect(option);
    };

    const isSelectDisabled = isDisabled || disabled;

    // Handle when options length is zero
    if (options.length <= 0) {
        return null; // Return null to avoid rendering anything
    }


    return (
        <div className={`zoobbe-select ${className} ${isSelectDisabled ? 'disabled' : ''}`} ref={selectRef}>
            <div
                ref={triggerRef}
                className={`zoobbe-select-trigger ${isOpen ? 'active' : ''} ${isSelectDisabled ? 'disabled' : ''}`}
                onClick={() => !isSelectDisabled && setIsOpen(!isOpen)}
            >
                {selectedOption?.label || 'Select an option'}

                <span className="material-symbols-outlined">
                    keyboard_arrow_down
                </span>

            </div>
            {!isSelectDisabled && isOpen && (
                <ul className={`zoobbe-select-options ${showDescription ? 'with-description' : ''} ${openUp ? 'open-up' : ''}`}>
                    {options.map((option) => (
                        <li
                            key={option?.value}
                            onClick={() => handleOptionClick(option)}
                            className={`zoobbe-select-option${selectedOption?.value === option?.value ? ' selected' : ''}${option?.isDanger ? ' danger' : ''}`}
                        >
                            <div className="option-content">
                                <div className="option-label">{option?.label}</div>
                                {showDescription && option?.description && (
                                    <div className="option-description">{option?.description}</div>
                                )}
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default ZoobbeSelect;
